module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-list"
  }, [_c('div', {
    staticClass: "breadcrumb-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/courseList'
      }
    }
  }, [_vm._v("自有课程")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(this.$route.query.id ? "编辑特色课程" : "新建特色课程"))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main-box"
  }, [_c('Card', {
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("特色课程基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formExtra,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "特色课程名称:"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formExtra.name),
      callback: function($$v) {
        _vm.$set(_vm.formExtra, "name", $$v)
      },
      expression: "formExtra.name"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "特色课程图片:"
    }
  }, [_c('el-row', {
    staticClass: "row-bg",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "flex"
    }
  }, [(_vm.formExtra.image != '') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.formExtra.image,
      "width": "80px",
      "height": "80px"
    }
  })]) : (this.backupImage != '') ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('img', {
    attrs: {
      "src": this.backupImage,
      "width": "80px",
      "height": "80px"
    }
  })]) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('Upload', {
    attrs: {
      "action": "/aries-api/resource/upload",
      "accept": "image/jpeg, image/gif, image/png",
      "before-upload": _vm.onBeforeUpload,
      "on-success": _vm.onSuccessUploadPkgImage,
      "data": _vm.uploadData,
      "show-upload-list": false
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    }
  }, [_vm._v("\n                      上传\n                      "), _c('i', {
    staticClass: "el-icon-upload el-icon--right"
  })])], 1)], 1), _vm._v(" "), (_vm.formExtra.image != '') ? _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "danger"
    },
    on: {
      "click": _vm.delFrontCover
    }
  }, [_vm._v("\n                      删除\n                      "), _c('i', {
    staticClass: "el-icon-delete"
  })])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "级别:"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "185px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formExtra.level),
      callback: function($$v) {
        _vm.$set(_vm.formExtra, "level", $$v)
      },
      expression: "formExtra.level"
    }
  }, _vm._l((_vm.levelList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "关联资源:"
    }
  }, [_c('courseAddBook', {
    on: {
      "choseResult": _vm.multyaddBooks
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "800px"
    },
    attrs: {
      "rows": 5,
      "type": "textarea"
    },
    model: {
      value: (_vm.formExtra.desc),
      callback: function($$v) {
        _vm.$set(_vm.formExtra, "desc", $$v)
      },
      expression: "formExtra.desc"
    }
  })], 1)], 1)], 1)])]), _vm._v(" "), _c('div', [_c('el-button', {
    staticStyle: {
      "margin-left": "45%",
      "margin-top": "10px",
      "margin-bottom": "50px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loadingBtn
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.cancelEdit
    }
  }, [_vm._v("取消")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09b5a0cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/course/extraAddNew.vue
// module id = 656
// module chunks = 1